import { Chip, ChipProps } from '@mui/material'
import { CellProps } from 'react-table'

import { OfflineConsultation } from '@/core/offline'

export function PatientGenderCell({ value }: CellProps<OfflineConsultation, OfflineConsultation['patient']['userInfo']['gender']>) {
  if (!value) return null

  let color: ChipProps['color']
  switch (value) {
    case 'M':
      color = 'primary'
      break
    case 'F':
      color = 'secondary'
      break
    default:
      color = 'info'
      break
  }

  return <Chip color={color} label={value} size="small" variant="filled" />
}
